import { all, call, put, takeLatest } from 'redux-saga/effects';
import countries from './../../data/countries.json';

export function* fetchCountry(action) {
  try {
    let cntry_id = window.localStorage.getItem('cntry_id');
    if (cntry_id === null) {
      const response = yield call(() => fetch('https://pro.ip-api.com/json/?key=32Wwk927Aclk2di'));
      if (response.ok) {
        const json = yield call([response, 'json']);
        let countryInfo = countries.find((ele) => ele.id === json.countryCode.toLowerCase());
        if (countryInfo === undefined) {
        } else {
          yield put({ type: 'COUNTRY_CHANGED', country: countryInfo.id });
        }
      } else {
        console.log(response.status, response.statusText);
      }
    }
  } catch (error) {
    console.log(error);
  }
}

async function webpIsSupported() {
  // If the browser doesn't has the method createImageBitmap, you can't display webp format
  if (!window.createImageBitmap) return false;

  // Base64 representation of a white point image
  const webpData = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=';

  // Retrieve the Image in Blob Format
  const blob = await fetch(webpData).then((r) => r.blob());

  // If the createImageBitmap method succeeds, return true, otherwise false
  return window.createImageBitmap(blob).then(
    () => true,
    () => false,
  );
}

export function* checkWebpSupport() {
  let result = yield call(webpIsSupported);
  yield put({ type: 'CHECKED_WEBP_SUPPORT', result: result });
}

export function* countryWatcher() {
  yield takeLatest('INIT_COUNTRY', fetchCountry);
}

export function* webpSupportWatcher() {
  yield takeLatest('CHECKING_WEBP_SUPPORT', checkWebpSupport);
}

export default function* rootSaga() {
  yield all([countryWatcher(), webpSupportWatcher()]);
}
